import {Component, OnInit, OnDestroy , ViewChild} from '@angular/core';
import {MessageService} from '../message.service';
import {NotifierService} from 'angular-notifier';
import {Router} from '@angular/router';
import {RestApiService} from '../rest-api.service';
import {NgbModal , NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Formatters} from 'angular-slickgrid';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-module-user-role',
  templateUrl: './module-user-role.component.html',
  styleUrls: ['./module-user-role.component.css']
})
export class ModuleUserRoleComponent implements OnInit, OnDestroy {

  displayed = true;
  selected: number;
  clientSelected: number;
  roleSelected: number;
  moduleSelected: number;
  userSelected: any;
  show: boolean;
  totalData: number;
  selectedTitles: any[];
  respObject: any;
  clients = [];
  module = [];
  role = [];
  users = [];
  clientName: string;
  moduleName: string;
  userName: string;
  roleName: string;
  displayData: any;
  notAdmin = true;
  add: boolean;
  del: boolean;
  edit: boolean;
  view: boolean;

  isError = false;
  errorMessage: string;
  private notifier: NotifierService;
  parents = [];
  parentSelected: number;
  private parentName: any;
  private clientId: number;
  private baseFlag: any;
  private cname: any;
  nextOffset: number;
  previousOffset: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private userAuth: Subscription;
  private adminAuth: Subscription;
  offset: number;
  dataLoaded: boolean;
  userId:number;

  isLoading = false;
  searchUser: FormControl = new FormControl();
  showSearch = true;
  searchData: FormControl = new FormControl();
  idSelected:any;
  usrs1 = [];
  @ViewChild('scarch_content') private scarch_content;
  private searchModalReference: NgbModalRef;




  constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
              private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      switch (item.type) {
        case 'change':
          // console.log('changed');
          if (!this.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {

          }
          break;
        case 'delete':
          if (this.baseFlag) {
            if (!this.del) {
              this.notifier.notify('error', 'You do not have delete permission');
            } else {
              this.deleteItem(item);
            }
          } else {
            if (!this.messageService.del) {
              this.notifier.notify('error', 'You do not have delete permission');
            } else {
              this.deleteItem(item);
            }
          }
          break;
      }
    });
    this.messageService.getUserAuth().subscribe(details => {
      console.log(JSON.stringify(details));
      if (details.length > 0) {
        this.add = details[0].addFlag;
        this.del = details[0].deleteFlag;
        this.view = details[0].viewFlag;
        this.edit = details[0].editFlag;
      }
    });
    this.messageService.getSelectedItemData().subscribe(selectedTitles => {
      if (selectedTitles.length > 0) {
        this.show = true;
        this.selected = selectedTitles.length;
      } else {
        this.show = false;
      }
    });
  }

  deleteItem(item) {
    if (confirm('Are you sure?')) {
      this._rest.deleteModuleUserClient({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.messageService.sendAfterDelete(item.id);
        } else {
          this.notifier.notify('error', this.respObject.errorMessage);
        }
      }, (err) => {
        this.notifier.notify('error', this.respObject.errorMessage);
      });
    }
  }

  ngOnInit() {

    // this._rest.getClient().subscribe((res) => {
    //   this.respObject = res;
    //   if (this.respObject.success) {
    //     this.respObject.clients.unshift({id: 0, name: 'Select Client'});
    //     this.clients = this.respObject.clients;
    //     this.clientSelected = 0;
    //   } else {
    //   }
    // }, (err) => {
    //
    // });
    this.dataLoaded = false;
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.paginationType = 'next';
    this.displayData = {
      pageName: 'View Module Role User Mapping',
      openModalButton: 'Module Role User Map',
      searchModalButton: 'Search',

      breadcrumb: 'ModuleRoleUserMap',
      folderName: 'All Module Role User Map',
      tabName: 'Module , Role and User Mapping'
    };
    const columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
      {
        id: 'module', name: 'Module', field: 'module_name', sortable: true, filterable: true
      },
      {
        id: 'ROLE_NAME', name: 'Role', field: 'role_name', sortable: true, filterable: true
      },
      {
        id: 'client_name', name: 'Client ', field: 'client_name', sortable: true, filterable: true
      },
      {
        id: 'user', name: 'User Name', field: 'user_name', sortable: true, filterable: true
      },
      {
        id: 'menu_name', name: 'Menu ', field: 'menu_name', sortable: true, filterable: true
      }
    ];

    this.messageService.setColumnDefinitions(columnDefinitions);
    // this.messageService.setGridWidth(1000);
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
        this.view = auth[0].viewFlag;
        this.add = auth[0].addFlag;
        this.edit = auth[0].editFlag;
        this.del = auth[0].deleteFlag;
        this.clientId = auth[0].clientId;
        this.baseFlag = auth[0].baseFlag;
        this.onPageLoad();
      });
      this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
        if (details.length > 0) {
          this.add = details[0].addFlag;
          this.del = details[0].deleteFlag;
          this.view = details[0].viewFlag;
          this.edit = details[0].editFlag;
          this.clientId = details[0].clientId;
          this.baseFlag = details[0].baseFlag;
          this.onPageLoad();
        }
      });
    }
    this.searchUser.valueChanges.subscribe(
        psOrName => {
            this.isLoading = true;
            if (psOrName !== '') {
                this._rest.searchAllUser(this.clientId, psOrName , this.roleSelected).subscribe((res1) => {
                    this.respObject = res1;
                    this.isLoading = false;
                    if (this.respObject.success) {
                        this.users = this.respObject.details;
                        // console.log("true"+ JSON.stringify(this.users));
                    } else {
                        this.notifier.notify('error', this.respObject.errorMessage);
                    }
                }, (err) => {
                    this.isLoading = false;
                    this.notifier.notify('error', this.messageService.SERVER_ERROR);
                });
            } else {
              this.users = [];
              this.userName = '';
              this.isLoading = false;
            }
        });
  }

  onPageLoad() {
        if (this.baseFlag) {
          this.notAdmin = false;
          this._rest.getClient().subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
              this.respObject.clients.unshift({id: 0, name: 'Select Client'});
              this.clients = this.respObject.clients;
              this.clientSelected = 0;
            } else {
              this.notifier.notify('error', this.respObject.errorMessage);
            }
          }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
          });
        } else {
          // console.log('------------>' + this.clientId);
          this.clientSelected = this.clientId;
          this._rest.getModulesByClientId(this.clientSelected).subscribe((res1) => {
            this.respObject = res1;
            // console.log(JSON.stringify(this.respObject));
            if (this.respObject.success) {
              this.isError = false;
              this.respObject.modules.unshift({id: 0, name: 'Select Modules'});
              this.module = this.respObject.modules;
              this.moduleSelected = 0;
            } else {
              this.isError = true;
              this.errorMessage = this.respObject.errorMessage;
            }
          }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
          });
          this._rest.getRoleClientWise(this.clientSelected).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
              this.isError = false;
              this.respObject.roles.unshift({id: 0, name: 'Select Role'});
              this.role = this.respObject.roles;
              this.roleSelected = 0;
            } else {
              this.isError = true;
              this.errorMessage = this.respObject.errorMessage;
            }
          }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
          });
        }
    this.getTableData();
  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  onClientChange(selectedIndex) {
    this.clientName = this.clients[selectedIndex].name;
    this._rest.getModulesByClientId(this.clientSelected).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.isError = false;
        this.respObject.modules.unshift({id: 0, name: 'Select Modules'});
        this.module = this.respObject.modules;
        this.moduleSelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
    this._rest.getRoleClientWise(this.clientSelected).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.isError = false;
        this.respObject.roles.unshift({id: 0, name: 'Select Role'});
        this.role = this.respObject.roles;
        this.roleSelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }

  openModal(content) {
    if (this.baseFlag) {
      if (!this.add) {
        this.notifier.notify('error', 'You do not have add permission');
      } else {
        this.isError = false;
        this.clientSelected = 0;
        this.roleSelected = 0;
        this.moduleSelected = 0;
        this.parentSelected = 0;
        this.userSelected = '';
        this.modalService.open(content).result.then((result) => {
        }, (reason) => {
        });
      }
    } else {
      if (!this.messageService.add) {
        this.notifier.notify('error', 'You do not have add permission');
      } else {
        this.isError = false;
        this.roleSelected = 0;
        this.moduleSelected = 0;
        this.parentSelected = 0;
        this.userSelected = '';
        this.modalService.open(content).result.then((result) => {
        }, (reason) => {

        });
      }
    }
  }



  searchModal() {
    if (this.baseFlag) {
      if (!this.add) {
        this.notifier.notify('error', 'You do not have add permission');
      } else {
      
        this.idSelected = '';

        this.searchModalReference = this.modalService.open(this.scarch_content);
        this.searchModalReference.result.then((result) => {
        }, (reason) => {
  
        });
        }
    } else {
      if (!this.messageService.add) {
        this.notifier.notify('error', 'You do not have add permission');
      } else {
        
        this.idSelected ='';
        this.searchModalReference = this.modalService.open(this.scarch_content);
        this.searchModalReference.result.then((result) => {
        }, (reason) => {
  
        });
        }
    }
  }
  getUserDetails() {
    for (let i = 0; i < this.users.length; i++) {
        if (this.users[i].login_name === this.userSelected) {
            this.userId = this.users[i].id;
            this.userName = this.users[i].name;
        }
    }
}




search() {

  this._rest.searchAllModuleRoleUserMap(this.idSelected, this.clientId).subscribe((res1) => {
    this.respObject = res1;
    this.isLoading = false;
    if (this.respObject.success) {
        this.usrs1 = this.respObject.details;
        this.messageService.setTotalData(this.usrs1.length);
        this.messageService.setGridData(this.usrs1);
        this.searchModalReference.close();

    } else {
        this.notifier.notify('error', this.respObject.errorMessage);
    }
}, (err) => {
    this.isLoading = false;
    this.notifier.notify('error', this.messageService.SERVER_ERROR);
});

}





  save() {
    const data = {
      client_id: this.clientSelected,
      module_id: this.moduleSelected,
      role_id: this.roleSelected,
        refer_user_id: this.userId,
      menuId: this.parentSelected,
      createdBy: this.messageService.getUserId()
    };
    if (!this.messageService.isBlankField(data)) {
      this._rest.mapModuleUserClient(data).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.totalData = this.totalData + 1;
          this.messageService.setTotalData(this.totalData);
          const id = this.respObject.id;
          this.messageService.setRow({
            id: id,
            module_name: this.moduleName,
            menu_name: this.parentName,
            role_name: this.roleName,
            client_name: this.clientName,
            user_name: this.userSelected
          });
          if (this.totalData <= this.pageSize * this.page_no) {
              this.offset = id;
              this.nextOffset = 0;
          } else {
              this.nextOffset = this.offset;
          }
          if (this.baseFlag) {
            this.clientSelected = 0;
          }
          this.moduleSelected = 0;
          this.roleSelected = 0;
          this.parentSelected = 0;
          this.userSelected = '';
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = this.messageService.SERVER_ERROR;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
  }

  getTableData() {
    this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }

  getData(paginationObj) {
    const offset = paginationObj.offset;
    const paginationType = paginationObj.paginationType;
    this.dataLoaded = false;
    if (this.baseFlag) {
      if (!this.view) {
        this.notifier.notify('error', 'You do not have view permission');
      } else {
        this._rest.getMappedModuleUserClient(offset, this.pageSize, paginationType).subscribe((res) => {
          this.respObject = res;
          this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
          this.notifier.notify('error', err);
        });
      }
    } else {
      if (!this.messageService.view) {
        this.notifier.notify('error', 'You do not have view permission');
      } else {
        this._rest.getMappedModuleUserClientCWise(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
          this.respObject = res;
          this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
          this.notifier.notify('error', err);
        });
      }
    }
  }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
          this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

  onModuleChange(selectedIndex: any) {
    this.moduleName = this.module[selectedIndex].name;
    this._rest.getMenuDtlsAllClientWise(this.clientSelected, this.moduleSelected).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.isError = false;
        this.respObject.details.unshift({id: 0, name: 'Select Menu'});
        this.parents = this.respObject.details;
        this.parentSelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }

  onRoleChange(selectedIndex: any) {
    this.roleName = this.role[selectedIndex].name;
  }

  onParentChange(selectedIndex: any) {
    this.parentName = this.parents[selectedIndex].name;
  }

  onUserChange(selectedIndex: any) {
    this.userName = this.users[selectedIndex].name;
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  onPageSizeChange(value: any) {
    this.page_no = 0;
    this.nextOffset = 0;
    this.pageSize = value;
    this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }

  ngOnDestroy(): void {
    if (this.userAuth) {
      this.userAuth.unsubscribe();
    }
    if (this.adminAuth) {
      this.adminAuth.unsubscribe();
    }
  }
}
